import { getInhabitancyEmailRecipients } from '../../../../../api'
import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../constants/common'
import {
  createEmailThread,
  EMAIL_COPY_TO_ARCHIVE_FORM_FIELDS_PROPS,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
  EMAIL_CREATION_FORM_RECIPIENT_FIELD_EMAIL_TYPE,
  EMAIL_CREATION_FORM_TEMPLATE_FOLDER_PRIVATE,
  toEmailRecipientSelectItem,
  useSendEmail,
  withEmailCopyToArchiveUsers,
} from '../../../../Email'
import { UserProfileTabId, useUserProfileContext } from '../../../../User'

export function useUserProfilePageCreateEmailAction() {
  const {
    closeEmailFormModal,
    handleCloseModal,
    handleReloadTabs,
    setEmailFormModal,
    setModal,
    userData,
  } = useUserProfileContext()

  async function handleSubmitEmail(payload) {
    return createEmailThread(
      withEmailCopyToArchiveUsers(payload, [userData.id])
    )
  }

  function handleSuccessSending() {
    handleReloadTabs([UserProfileTabId.Emails])
  }

  const { handleOpenCreationEmail } = useSendEmail({
    excludeIds: EMPTY_LIST,
    filterValues: EMPTY_OBJECT,
    formFieldsProps: EMAIL_COPY_TO_ARCHIVE_FORM_FIELDS_PROPS,
    getRecipients: getInhabitancyEmailRecipients,
    massMailing: false,
    selectAllPages: false,
    selectedIds: userData ? [userData.id] : EMPTY_LIST,
    singleTemplateFolder: EMAIL_CREATION_FORM_TEMPLATE_FOLDER_PRIVATE,
    onCloseEmailFormModal: closeEmailFormModal,
    onCloseModal: handleCloseModal,
    onSetEmailFormModal: setEmailFormModal,
    onSetModal: setModal,
    onSubmit: handleSubmitEmail,
    onSuccessSending: handleSuccessSending,
  })

  function handleClickEmail({ email, type }) {
    handleOpenCreationEmail({
      initialValues: {
        [EMAIL_CREATION_FORM_FIELD_NAME_TO]: [
          toEmailRecipientSelectItem({ ...userData, email, type }),
        ],
      },
    })
  }

  function handleClickCreateEmail() {
    // The inhabitancy recipients loader does not serve staff members, so a
    // staff profile gets its auth email preselected from the profile data.
    if (userData?.isStaff) {
      handleClickEmail({
        email: userData.email,
        type: EMAIL_CREATION_FORM_RECIPIENT_FIELD_EMAIL_TYPE.main,
      })
    } else {
      handleOpenCreationEmail()
    }
  }

  return { handleClickCreateEmail, handleClickEmail }
}
